module.exports = __webpack_public_path__ + "img/login-credible.56d00c19.png";